module.exports = __webpack_public_path__ + "static/media/headerLogo.55bcf926.svg";